import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const UpdateSalesRepGrossProfitOverrideDocument = gql`
  mutation UpdateSalesRepGrossProfitOverride(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
    $variantPacks: [SalesRepUpdateVariantPackGrossProfitInput!]!
    $deliveryDate: String
    $expirationDate: String
  ) {
    updateSalesRepGrossProfitPercentageOverrides(
      delivery_date: $deliveryDate
      expiration_date: $expirationDate
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
      update_source: ORDER_ENTRY
      variant_packs: $variantPacks
    ) {
      variant_pack_id
      default_price_in_micros
      price_in_micros
      sales_rep_price_in_micros
      sales_rep_gross_profit_in_percentage
      sales_rep_metadata {
        updated_by_name
      }
      unit_count
    }
  }
`;
export type UpdateSalesRepGrossProfitOverrideMutationFn =
  Apollo.MutationFunction<
    Types.UpdateSalesRepGrossProfitOverrideMutation,
    Types.UpdateSalesRepGrossProfitOverrideMutationVariables
  >;
export function useUpdateSalesRepGrossProfitOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.UpdateSalesRepGrossProfitOverrideMutation,
    Types.UpdateSalesRepGrossProfitOverrideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.UpdateSalesRepGrossProfitOverrideMutation,
    Types.UpdateSalesRepGrossProfitOverrideMutationVariables
  >(UpdateSalesRepGrossProfitOverrideDocument, options);
}
export type UpdateSalesRepGrossProfitOverrideMutationHookResult = ReturnType<
  typeof useUpdateSalesRepGrossProfitOverrideMutation
>;
export type UpdateSalesRepGrossProfitOverrideMutationResult =
  Apollo.MutationResult<Types.UpdateSalesRepGrossProfitOverrideMutation>;
export type UpdateSalesRepGrossProfitOverrideMutationOptions =
  Apollo.BaseMutationOptions<
    Types.UpdateSalesRepGrossProfitOverrideMutation,
    Types.UpdateSalesRepGrossProfitOverrideMutationVariables
  >;
